import React, { useState } from "react";
import { Site } from "../../types/Emailstypes";
import { ActiveSiteBadge } from "../SharedUI/GBPSharedUI";
import GroupssSection from "../GroupdSection/GroupsSection";
import ListingManagement from "../../../listings/ListingManagement";

interface ListingSectionProps {
  site: Site;
  localSearch: string;
  setLocalSearch: (v: string) => void;
}

const ListingSection: React.FC<ListingSectionProps> = ({
  site,
  localSearch,
}) => {
  const [selectedGroupId,   setSelectedGroupId]   = useState<number | null>(null);
  const [selectedAccountId, setSelectedAccountId] = useState<string>("");

  const handleNavigate = (accountId?: string) => {
    if (!accountId) return;
    const raw       = accountId.split("/").pop() || accountId;
    const numericId = Number(raw);
    if (!isNaN(numericId)) setSelectedGroupId(numericId);
    setSelectedAccountId(accountId);
    sessionStorage.setItem("gbp_selected_account_id", accountId);
  };

  return (
    <div className="animate-fade-in">

      <div className="mb-6 flex flex-wrap items-center gap-3 pb-4 border-b border-slate-100">
        <ActiveSiteBadge site={site} />
        <div className="h-4 w-px bg-slate-200" />
        <span className="text-[12px] font-semibold text-slate-400">
          {site.groupCount} groupe{site.groupCount !== 1 ? "s" : ""} disponible
          {site.groupCount !== 1 ? "s" : ""}
        </span>
      </div>

      <GroupssSection
        searchQuery={localSearch}
        onNavigateToGBP={handleNavigate}
        subjectEmail={site.subjectEmail}/> 

      {selectedGroupId !== null && (
        <div className="mt-6 animate-fade-in">
          <ListingManagement
            websiteId={selectedGroupId}
            gbpAccountId={selectedAccountId}
            subjectEmail={site.subjectEmail}  
          />
        </div>
      )}
    </div>
  );
};

export default ListingSection;